import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { DashboardAssigment } from '../entities/schema/dashboardassigment.entity';
import { Dashboard } from '../entities/schema/dashboard.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class DashboardService extends ODataEntityService<Dashboard> {
  constructor(protected client: ODataClient) {
    super(client, 'Dashboard', 'entities.schema.Dashboard');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public reportsAssigments(entity: EntityKey<Dashboard>): ODataNavigationPropertyResource<DashboardAssigment> {
    return this.entity(entity).navigationProperty<DashboardAssigment>('reportsAssigments');
  }
  public status(entity: EntityKey<Dashboard>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<Dashboard>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
